import './FormPanel.scss';

import classNames from 'classnames';

import type {
  FormPanelBodyProps,
  FormPanelFooterProps,
  FormPanelHeaderProps,
  FormPanelProps,
  FormPanelSectionHeaderProps,
} from './FormPanel.types';

const FormPanelRoot = ({ children, className, maxWidth = 'md', layout = 'default' }: FormPanelProps) => (
  <div
    className={classNames(
      'form-panel',
      `form-panel--max-${maxWidth}`,
      layout === 'sectioned' && 'form-panel--sectioned',
      className,
    )}
  >
    {children}
  </div>
);

const FormPanelSectionHeader = ({ title, subtitle, className }: FormPanelSectionHeaderProps) => (
  <div className={classNames('form-panel__section-header', className)}>
    <h2 className='mb-0'>
      {title}
      {subtitle && (
        <>
          {' '}
          <span className='form-panel__section-subtitle'>{subtitle}</span>
        </>
      )}
    </h2>
  </div>
);

const FormPanelHeader = ({ title, subtitle, className }: FormPanelHeaderProps) => (
  <div className={classNames('form-panel__page-header', className)}>
    <h1>{title}</h1>
    {subtitle && <p className='form-panel__page-subtitle'>{subtitle}</p>}
  </div>
);

const FormPanelBody = ({ children, className }: FormPanelBodyProps) => (
  <div className={classNames('form-panel__body', className)}>{children}</div>
);

const FormPanelFooter = ({ children, preActions, after, className, variant }: FormPanelFooterProps) => (
  <div
    className={classNames(
      'form-panel__footer',
      variant === 'actions' && 'form-panel__footer--actions',
      variant === 'actions-split' && 'form-panel__footer--actions-split',
      className,
    )}
  >
    {preActions}
    <div
      className={classNames(
        'form-panel__footer-actions',
        variant === 'actions' && 'form-panel__footer-actions--end',
        variant === 'actions-split' && 'form-panel__footer-actions--split',
      )}
    >
      {children}
    </div>
    {after}
  </div>
);

export const FormPanel = Object.assign(FormPanelRoot, {
  SectionHeader: FormPanelSectionHeader,
  Header: FormPanelHeader,
  Body: FormPanelBody,
  Footer: FormPanelFooter,
});
